export const BEFORE_CLAIM_WEEKLY_PROMO = "BEFORE_CLAIM_WEEKLY_PROMO";
export const CLAIM_WEEKLY_PROMO = "CLAIM_WEEKLY_PROMO";
export const NETWORK_ERROR_CLAIMING_WEEKLY_PROMO = "NETWORK_ERROR_CLAIMING_WEEKLY_PROMO";


export const BEFORE_FETCH_PREVIOUS_WEEKLY_PROMO_WINNERS = "BEFORE_FETCH_PREVIOUS_WEEKLY_PROMO_WINNERS";
export const FETCH_PREVIOUS_WEEKLY_PROMO_WINNERS = "FETCH_PREVIOUS_WEEKLY_PROMO_WINNERS";
export const NETWORK_ERROR_FETCHING_PREVIOUS_WEEKLY_PROMO_WINNERS = "NETWORK_ERROR_FETCHING_PREVIOUS_WEEKLY_PROMO_WINNERS";